module.exports = __webpack_public_path__ + "static/media/bg35.236aac96.jpg";